module.exports = __webpack_public_path__ + "assets/img/cancel.35138c18.svg";